import { Controller } from "@hotwired/stimulus";

// The cashier's remittance (11/10/2026): each day says its cash and its
// cheques apart; the totals — cash, cheques, the whole — follow the days
// ticked, and the amount proposed is shown before the cashier confirms.
export default class extends Controller {
  static targets = ["day", "cash", "cheques", "total", "amount", "float", "incidents"];
  static values = { currency: { type: String, default: "F CFA" } };

  connect() {
    this.refresh();
  }

  refresh() {
    let cash = 0;
    let cheques = 0;
    let incidents = 0;
    this.dayTargets.forEach((box) => {
      const card = box.closest("[data-remittance-day]");
      if (card) card.classList.toggle("opacity-50", !box.checked);
      if (!box.checked) return;
      cash += Number(box.dataset.cash || 0);
      cheques += Number(box.dataset.cheques || 0);
      incidents += Number(box.dataset.incidents || 0);
    });
    // The float given back with the remittance is cash handed over too.
    if (this.hasFloatTarget && this.floatTarget.checked) cash += Number(this.floatTarget.dataset.float || 0);
    if (this.hasIncidentsTarget) {
      this.incidentsTarget.textContent = this.money(incidents);
      this.incidentsTarget.closest("[data-remittance-incidents]").hidden = incidents === 0;
    }
    this.cashTarget.textContent = this.money(cash);
    this.chequesTarget.textContent = this.money(cheques);
    this.totalTarget.textContent = this.money(cash + cheques);
    if (this.hasAmountTarget) this.amountTarget.placeholder = new Intl.NumberFormat("fr-FR").format(cash + cheques);
  }

  money(amount) {
    return `${new Intl.NumberFormat("fr-FR").format(amount)} ${this.currencyValue}`;
  }
}
